import * as Sentry from '@sentry/react';
import { OpenPanel } from '@openpanel/web';
import { env } from './env';

interface OpRuntimeConfig {
  clientId?: string;
  environment?: string;
}

interface OpClient {
  track: (name: string, properties?: Record<string, unknown>) => void;
  identify: (payload: { profileId: string }) => void;
  clear: () => void;
  setGlobalProperties: (properties: Record<string, unknown>) => void;
}

const runtimeConfig =
  (globalThis as Record<string, unknown>).__OP_CONFIG__ !== undefined
    ? ((globalThis as Record<string, unknown>).__OP_CONFIG__ as OpRuntimeConfig)
    : {};

const noopOp: OpClient = {
  track: () => undefined,
  identify: () => undefined,
  clear: () => undefined,
  setGlobalProperties: () => undefined,
};

const nonEmpty = (value: string | undefined) => (value === '' ? undefined : value);
const clientId = nonEmpty(runtimeConfig.clientId) ?? env.VITE_OPENPANEL_CLIENT_ID;
const environment = nonEmpty(runtimeConfig.environment) ?? env.VITE_APP_ENV;

export function initMonitoring() {
  if (!env.VITE_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    release: `els-client@${__APP_VERSION__}`,
    sendDefaultPii: false,
    tracesSampleRate: env.VITE_APP_ENV === 'production' ? 0.2 : 1,
  });
}

export const op: OpClient = clientId
  ? new OpenPanel({
      clientId,
      apiUrl: 'https://octopus.elscms.com/api',
      trackScreenViews: true,
      trackOutgoingLinks: true,
    })
  : noopOp;

if (clientId) {
  op.setGlobalProperties({ app_version: __APP_VERSION__, environment });
}
